import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import { type FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEffectOnce } from '../../../../../../../hooks/use-effect-once';
import { useActivatedIntegration } from '../../../../../../../hooks/use-activated-integration';
import { ConfigurationsContainer } from '../../../containers/ConfigurationsContainer';
import { useFetchXeroSettings } from '../hooks/useFetchXeroSettings';
import type {
  XeroConfigurationControl,
  XeroConfigurationFormValues,
} from '../XeroConfigurationFormSchema';
import { CreditMemosConfigurationSection } from './components/CreditMemosConfigurationSection';
import { InvoicesConfigurationSection } from './components/InvoicesConfigurationSection';
import { PaymentsConfigurationSection } from './components/PaymentsConfigurationSection';
import { TaxConfigurationSection } from './components/TaxConfigurationSection';


type XeroConfigurationFormProps = {
  control: XeroConfigurationControl;
};

export const XeroConfigurationForm: FC<XeroConfigurationFormProps> = ({ control }) => {
  const { configuration } = useFetchXeroSettings();
  const { reset } = useFormContext<XeroConfigurationFormValues>();
  const isStripeConnected = useActivatedIntegration(INTEGRATION_PROVIDERS.stripe);

  useEffectOnce(() => {
    reset(configuration);
  });

  return (
    <FormContainer>
      <Typography variant="h5">Configurations</Typography>
      <ConfigurationsContainer>
        <InvoicesConfigurationSection control={control} defaultValues={configuration} />
        <CreditMemosConfigurationSection control={control} defaultValues={configuration} />
        <TaxConfigurationSection control={control} defaultValues={configuration} />
        {isStripeConnected && (
          <PaymentsConfigurationSection control={control} defaultValues={configuration} />
        )}
      </ConfigurationsContainer>
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});
